import { useQueryWithUserId } from '@northladder/services';

import { INBOUND_API } from '../../../inboundAPIClient';
import { IFetchPodDetailUrlOptions } from '../../../types';

interface IInboundPodDetailsQuery {
  queryParams: IFetchPodDetailUrlOptions;
}

/**
 * This is to track the Inbound details from the backend.
 */
const INBOUND_POD_DETAILS_KEY = 'inbound-pod-details-query';

export const useInboundPodDetailsQuery = ({
  queryParams,
}: IInboundPodDetailsQuery) => {
  const {
    ageFilter,
    inventoryTransactionId,
    podIdentifier,
    trayNumber,
    zone,
    recordType,
    searchText,
  } = queryParams;
  const { data, isError, error, isPending } = useQueryWithUserId({
    queryKey: [
      INBOUND_POD_DETAILS_KEY,
      ageFilter,
      inventoryTransactionId,
      podIdentifier,
      trayNumber,
      zone,
      recordType,
      searchText,
    ],
    networkMode: 'always',
    queryFn: () => INBOUND_API.getPodDetailsWithAgingInfo(queryParams),
  });

  return {
    podFetchError: error,
    isPodFetchingError: isError,
    podDetailsData: data,
    isPodDetailsLoading: isPending,
  };
};
